export default __webpack_public_path__ + "img/7731b887a1c0434b363c45b5a6958b1f.svg";